module.exports = __webpack_public_path__ + "static/media/fallon-michael-jpiiDziFagQ-unsplash.528200fd.jpg";